import axiosInstance, {headers} from './axiosInstance';
import {
 ADD_TRIGGER, ALL_TRIGGERS,
DELETE_TRIGGER,

} from './config';

export interface PITrigger {
  /** Timestamp when generation is scheduled */
  generation_time: string; // ISO 8601 datetime string

  /** Timestamp when completion is scheduled */
  completion_time: string; // Optional ISO 8601 datetime string

  /** Timestamp when trigger was created */
  created_on: string; // Optional ISO 8601 datetime string

  /** Job id of google cloud task */
  cloud_task_job_id_generation: string;

  /** Job id of google cloud task */
  cloud_task_job_id_completion: string;
}

export const api = {
    async getAllTriggers()
    {
       return axiosInstance.get<PITrigger[]>(`${ALL_TRIGGERS}`, {headers:headers})
    },
    async addTrigger(formData:Partial<PITrigger>) {
        return axiosInstance.post<Partial<PITrigger>>(`${ADD_TRIGGER}`, formData,  {headers: headers});
    },

    async deleteTrigger(task_id:string) {
        return axiosInstance.post(`${DELETE_TRIGGER}`, {trigger_id: task_id},  {headers: headers});
    },


};
